import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { adminApi } from '@/lib/admin';
import { AdminShell } from '@/components/app/AdminShell';

export function AdminAuditPage() {
  const { t } = useTranslation();
  const { data: rows = [], isLoading } = useQuery({
    queryKey: ['admin', 'audit'],
    queryFn: () => adminApi.recentAudit(200),
    refetchInterval: 30_000,
  });

  return (
    <AdminShell
      title={t('admin.audit.title', { defaultValue: 'Admin audit trail' })}
      description={t('admin.audit.subtitle', { defaultValue: 'Every privileged action taken in the admin panel.' }) as string}
    >
      {isLoading ? (
        <div className="card-paper p-10 text-center text-ink-500 text-sm">{t('common.loading')}</div>
      ) : rows.length === 0 ? (
        <div className="card-paper p-12 text-center text-ink-500 text-sm">
          {t('admin.audit.empty', { defaultValue: 'No admin actions yet — the trail is clean.' })}
        </div>
      ) : (
        <div className="card-paper overflow-x-auto p-0">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-ink-500 border-b border-ink-100 bg-paper-100 text-[11px] uppercase tracking-[0.12em]">
                <th className="py-2.5 pl-5 pr-3 font-medium">{t('audit_log.th_when')}</th>
                <th className="py-2.5 px-3 font-medium">{t('audit_log.th_actor')}</th>
                <th className="py-2.5 px-3 font-medium">{t('audit_log.th_action')}</th>
                <th className="py-2.5 px-3 font-medium">{t('audit_log.th_target')}</th>
                <th className="py-2.5 px-3 font-medium">{t('audit_log.th_payload')}</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((e) => (
                <tr key={e.id} className="border-b border-ink-50 align-top hover:bg-paper-100/40">
                  <td className="py-2 pl-5 pr-3 num text-ink-700 text-xs whitespace-nowrap">
                    {new Date(e.created_at).toLocaleString()}
                  </td>
                  <td className="py-2 px-3 num text-xs text-ink-500">
                    {e.actor_id.slice(0, 8)}
                  </td>
                  <td className="py-2 px-3">
                    <span className="chip-citation">{e.action}</span>
                  </td>
                  <td className="py-2 px-3 num text-ink-700 text-xs">
                    {e.target_kind} · {e.target_id.slice(0, 12)}
                  </td>
                  <td className="py-2 px-3 text-xs text-ink-600 max-w-[40ch] truncate">
                    {e.payload ? JSON.stringify(e.payload) : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminShell>
  );
}
